export default __webpack_public_path__ + "static/media/vk.50fddb15.mp4";